exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-btn__content{letter-spacing:normal!important}.home-cover .carousel{background:#eee;width:100%;overflow:hidden}.home-cover .floating-box{position:absolute;left:1rem;top:0;display:flex;flex-direction:column;align-items:flex-start}@media (max-width:992px){.home-cover .floating-box{top:3rem}}.home-cover .floating-box h1,.home-cover .floating-box span{font-family:Baloo2}.home-cover .floating-box h6{font-family:Avenir-Heavy}@media (min-width:992px){.home-cover .floating-box{padding:60px 100px}}.home-cover .cover-image{height:500px;width:100%;-o-object-fit:cover;object-fit:cover}.home-cover .carousel-cell{width:100%;position:relative}.home-cover .flickity-page-dots{bottom:20px}.home-cover .flickity-page-dots .dot{width:12px;height:12px;opacity:1;background:transparent;border:2px solid #fff}.home-cover .flickity-page-dots .dot.is-selected{background:#fff}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};